var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "runs-box" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Mode"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("p", [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm._f("trans")(
                "Should the AI either follow the original image or create something completely new."
              )
            ) +
            "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "runs-container" }, [
        _c(
          "div",
          {
            staticClass: "runs-btn",
            class: {
              active: _vm.activeStage.settings.inpainting_fill === "original",
            },
            on: {
              click: function ($event) {
                return _vm.changeModeTo("original")
              },
            },
          },
          [
            _vm._v("\n      Original\n      "),
            _c(
              "div",
              {
                staticClass: "checkmark-box",
                class: {
                  active:
                    _vm.activeStage.settings.inpainting_fill === "original",
                },
              },
              [_c("i", { staticClass: "fa fa-check" })]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "runs-btn",
            class: {
              active:
                _vm.activeStage.settings.inpainting_fill === "latent_noise",
            },
            on: {
              click: function ($event) {
                return _vm.changeModeTo("latent_noise")
              },
            },
          },
          [
            _vm._v("\n      New\n      "),
            _c(
              "div",
              {
                staticClass: "checkmark-box",
                class: {
                  active:
                    _vm.activeStage.settings.inpainting_fill === "latent_noise",
                },
              },
              [_c("i", { staticClass: "fa fa-check" })]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }